import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";
import { api, setSessionExpiredHandler, setTokenGetter } from "@/lib/api";

const MeContext = createContext(null);
export const useMe = () => useContext(MeContext);

export function MeProvider({ children }) {
  const { getToken, isSignedIn, signOut } = useAuth();
  const [me, setMe] = useState(null);
  const [error, setError] = useState(false);

  setTokenGetter((opts) => getToken(opts));
  setSessionExpiredHandler(() => {
    toast.error("Votre session a expiré, merci de vous reconnecter.");
    signOut({ redirectUrl: "/sign-in" });
  });

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/me");
      setMe(data);
      setError(false);
    } catch {
      setError(true);
    }
  }, []);

  useEffect(() => {
    if (isSignedIn) reload();
  }, [isSignedIn, reload]);

  return <MeContext.Provider value={{ me, reload, error }}>{children}</MeContext.Provider>;
}
